import { IPricingPlan } from '@dataplace.ai/constants'

export const checkIfDisabledByPricingPlan = (
  plans: IPricingPlan[], tilePricingPlan: IPricingPlan, workspacePricingPlan: string,
): boolean => {
  const currentPlan = plans?.find(plan => plan.id === workspacePricingPlan)
  return (currentPlan && tilePricingPlan) ? currentPlan?.weight < tilePricingPlan?.weight : true
}
